import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

import { L2vpnSubscriptionDetails } from "../../../../../pages/subscription-detail/types";
import { PortSummary } from "../../../port-summary/port-summary";

type L2vpnEsi = L2vpnSubscriptionDetails["esis"][number];
type L2vpnEsiEndpoint = NonNullable<L2vpnEsi["endpoints"]>[number];

@Component({
  selector: "l2vpn-esi-panel",
  templateUrl: "l2vpn-esi-panel.html",
  host: { style: "display: contents" },
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [PortSummary],
})
export class L2vpnEsiPanel {
  esi = input.required<L2vpnEsi>();

  protected endpoints = computed(() => this.esi().endpoints ?? []);

  protected vlanrangeFor(endpoint: L2vpnEsiEndpoint): string[] {
    return endpoint.vlanrange ? [endpoint.vlanrange] : [];
  }
}
